import React, { useEffect, useState } from "react";
import {
  Form,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Label,
  Input,
} from "reactstrap";

//images
import imagePlaceholder from "../assets/images/users/user-dummy-img.jpg";
import { BasicDetailsTypes } from "../types/profile";

interface DataTypes {
  message: string | null;
  confirm: boolean;
}

interface VisitModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (data: any) => void;
  chatUserDetails: BasicDetailsTypes;
}

const ServiceModal = ({ isOpen, onClose, onConfirm, chatUserDetails }: VisitModalProps) => {

  const [data, setData] = useState<DataTypes>({
    confirm: false,
    message: chatUserDetails.obs ? chatUserDetails.obs : "",
  });

  const [obsTouched, setObsTouched] = useState(false);
  const obsIsValid = (data.message?.trim().length ?? 0) > 3;

  useEffect(() => {
    setData({
      confirm: data.confirm,
      message: data.message,
    });
  }, []);

  const onChangeData = (field: "confirm" | "message", value: string | boolean) => {
    let modifiedData: any = { ...data };
    if (value === "") {
      modifiedData[field] = null;
    } else {
      modifiedData[field] = value;
    }
    setData(modifiedData);
  };

  const [valid, setValid] = useState<boolean>(false);

  useEffect(() => {
    if (obsIsValid) {
      setValid(true);
    } else {
      setValid(false);
    }
  }, [data, obsIsValid]);


  return (
    <Modal
      isOpen={isOpen}
      toggle={onClose}
      tabIndex={-1}
      centered
      className="visitModal"
      contentClassName="shadow-lg border-0"
    >
      <ModalBody className="p-0">
        <div className="text-Leftbar p-4 pb-0">
          <h5 className="font-size-18 mb-4 text-uppercase text-truncate">
            Aceitar Atendimento do Cliente
          </h5>


          <Form>

            <div className="mb-3 d-flex align-items-end gap-4">

              {/* Confirmar template */}
              <div className="d-flex flex-column align-items-start">

                <Label
                  className="form-check-label mb-2"
                  htmlFor="privacy-lastseenSwitch"
                >
                  Sinalizar esse contato
                </Label>

                <div className="form-check form-switch m-0">
                  <input
                    type="checkbox"
                    className="form-check-input"
                    id="privacy-lastseenSwitch"
                    checked={data.confirm === true}
                    onChange={(e: any) => {
                      onChangeData("confirm", e.target.checked);
                    }}
                  />
                  Como marcado
                </div>
              </div>
            </div>

            <div className="">
              <Label
                htmlFor="AddContactModal-invitemessage-input"
                className="form-label"
              >
                Observação do atendimento
              </Label>
              <Input
                type="textarea"
                value={data.message || ""}
                valid={obsTouched && obsIsValid}
                invalid={obsTouched && !obsIsValid}
                onBlur={() => setObsTouched(true)}
                onChange={(e) => onChangeData("message", e.target.value)}
                className="form-control"
                id="AddContactModal-invitemessage-input"
                rows={3}
                placeholder="Observação do atendimento"
              />

              {obsTouched && !obsIsValid && (
                <div className="invalid-feedback d-block">
                  Informe uma observação
                </div>
              )}
            </div>
          </Form>

          <div className="mt-4 d-flex justify-content-center gap-4">
            <Button
              type="button"
              className="btn btn-primary avatar-md call-close-btn rounded-circle"
              color="primary"
              disabled={!valid}
              onClick={() => onConfirm(data)}
            >
              <span className="avatar-title bg-transparent font-size-24">
                <i className="bx bxs-calendar-check"></i>
              </span>
            </Button>

            <Button
              type="button"
              className="btn btn-danger avatar-md call-close-btn rounded-circle"
              color="danger"
              onClick={onClose}
            >
              <span className="avatar-title bg-transparent font-size-24">
                <i className="bx bx-window-close"></i>
              </span>
            </Button>
          </div>



        </div>

        <div className="p-4 bg-soft-primary mt-n4">
          <div className="mt-4 text-Leftbar">
            <h5 className="font-size-14 text-uppercase text-muted mt-2">
              {chatUserDetails ? `ID: ${chatUserDetails.idCliente}` : ""}
            </h5>
            <h5 className="font-size-14 text-uppercase text-muted mt-2">
              {chatUserDetails ? `CPF: ${chatUserDetails.cpfCnpj}` : ""}
            </h5>
            <h5 className="font-size-14 text-uppercase text-muted mt-2">
              {chatUserDetails ? `Região: ${chatUserDetails.regiao}` : ""}
            </h5>
          </div>

          <div className="mt-4 text-Leftbar">
            <h5 className="font-size-18 mb-0 text-truncate">
              {chatUserDetails ? `${chatUserDetails.fullName}` : ""}
            </h5>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default ServiceModal;
